import { render, staticRenderFns } from "./RecordAddContainer.vue?vue&type=template&id=d3382640"
import script from "./RecordAddContainer.vue?vue&type=script&lang=js"
export * from "./RecordAddContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports